function toPrice(n){

  let a = n/100;
  return a.toFixed(2)
}
export  {
  toPrice
}
